import React from 'react';
export const useControllerMirror = (name, params, __mirror) => {
    if (__mirror === null || __mirror === void 0 ? void 0 : __mirror.controller) {
        __mirror.controller[name] = params;
    }
    React.useEffect(() => {
        return () => {
            var _a;
            if ((_a = __mirror === null || __mirror === void 0 ? void 0 : __mirror.controller) === null || _a === void 0 ? void 0 : _a[name]) {
                delete __mirror.controller[name];
            }
        };
    }, []);
};
